import { useRef, useState, useEffect } from 'react';

export function useElementWidth<T extends HTMLElement>() {
	const ref = useRef<T>(null);
	const [width, setWidth] = useState<number | undefined>(undefined);

	useEffect(() => {
		if (ref.current && !width) {
			setWidth(ref.current.clientWidth);
		}
	}, [ref]);

	return {
		ref,
		width,
	};
}
